import { render, staticRenderFns } from "./ListarVentas.vue?vue&type=template&id=c1c9c648&"
import script from "./ListarVentas.vue?vue&type=script&lang=js&"
export * from "./ListarVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports